<template>
  <div v-click-outside="toggleHideDatePicker" class="date-picker">
    <sb-field :variation="variation">
      <sb-text-input
        :id="id"
        class="date-picker__input"
        ref="date-picker-display"
        v-model="dateValue"
        @click="toggleShowDatePicker"
        :placeholder="dateFormatPlaceholder"
        autocomplete="off"
      />
    </sb-field>
    <sb-popover
      :target="popoverTarget"
      :active="showDatePicker"
      placement="start"
      orientation="bottom"
      :position-fixed="true"
      @click.stop
    >
      <fade-transition>
        <sb-panel
          v-show="showDatePicker"
          variation="bare"
          class="date-picker__container"
        >
          <date-picker
            :selectedValue="dateValue"
            :options="reserveDateOptions"
            @selectedDate="handleDateChanged"
          />
        </sb-panel>
      </fade-transition>]
    </sb-popover>
  </div>
</template>

<script>
import SbDatePicker from '@/components/utils/SbDatePicker'
import DatePickerUtilities from '@utils/datepickerUtilities'
import isEqual from 'lodash/isEqual'

export default {
  name: 'PopoverDatePicker',
  components: {
    'date-picker': SbDatePicker
  },
  mixins: [],
  props: {
    value: {
      type: String,
      default: ''
    },
    variation: {
      type: String,
      default: 'default'
    },
    id: {
      type: String,
      default: null
    }
  },
  data: () => ({
    showDatePicker: false,
    reserveDateOptions: {
      format: DatePickerUtilities.getDateFormat(),
      useCurrent: false,
      icons: {
        previous: 'icon-chevron-left',
        next: 'icon-chevron-right'
      },
      minDate: DatePickerUtilities.format(),
      inline: true
    }
  }),
  mounted () {},
  destroyed () {},
  watch: {},
  computed: {
    dateFormatPlaceholder () {
      return this.reserveDateOptions.format
    },
    dateValue: {
      get () {
        return this.value
      },
      set (newVal) {
        this.emitDateChange(newVal)
      }
    },
    popoverTarget () {
      return this.$refs['date-picker-display']
    }
  },
  methods: {
    handleDateChanged (newDate) {
      if (!isEqual(newDate, this.dateValue)) this.emitDateChange(newDate)
      this.toggleHideDatePicker()
    },
    emitDateChange (newDate) {
      this.$emit('input', newDate)
    },
    toggleShowDatePicker () {
      this.showDatePicker = true
    },
    toggleHideDatePicker () {
      this.showDatePicker = false
    }
  },
  directives: {},
  filters: {},
  i18n: { messages: {} }
}
</script>

<style scoped lang='scss'>
.date-picker {
  &__input {
    font-family: proxima-nova, sans-serif !important;
  }
  &__container {
    z-index: 1;
  }
}
</style>
